import {
  validate100TextArea,
  validatelCountry,
  validateTextField,
  validateDesignation,
  validate150TextArea,
  validate200TextAreaNonMandatory,
  validateDisclaimer,
  validateEmail,
  validateFile,
  validatelCountrySate,
  validatelMobileNo,
  validateName,
  validateName2,
  validatePofilePicture,
  validateSelectField,
  validateSelectFieldSingle,
  validateTotalSelectField,
  validateNumber,
  validateUrl,
  validateSelectFieldMulti,
  validatelotherCountryCity,
} from "../common/dependencies/utils/validation";

export default {
  validateStep1: (params) => {
    const {
      full_name,
      current_designation,
      organization_name,
      uploadProfilePic,
    } = params;
    
    let formStatus = {};
    const fullnameStatus = validateName(
      full_name,
      "Please Enter Your Full Name"
    );
    const currentDesgnationStatus = validateDesignation(
      current_designation,
      "Please Enter Your Current Designation"
    );
    const OrganizationStatus = validateName2(
      organization_name,
      "Please Enter Organization Name"
    );
    const uploadProfilePicStatus = validatePofilePicture(
      uploadProfilePic,
      "Please Select Profile pic"
    );

    formStatus = {
      fullname: fullnameStatus.error,
      currentDesgnation: currentDesgnationStatus.error,
      orgName: OrganizationStatus.error,
      uploadProfilePic: uploadProfilePicStatus.error,
      hasErrors:
        fullnameStatus.hasError ||
        currentDesgnationStatus.hasError ||
        OrganizationStatus.hasError ||
        uploadProfilePicStatus.hasError,
    };
    return formStatus;
  },

  validateStep2: (params) => {
    
    const { email_id, phonevalue, gender, country, state, city,city_name } = params;
    // alert("validate" ,city_name)
    let formStatus = {};
    const emailStatus = validateEmail(
      email_id,
      "*Please Enter Valid Email Address"
    );
    const contactNoStatus = validatelMobileNo(
      phonevalue,
      "*Please Enter Valid Phone Number ",
      country
    );
    const genderStatus = validatelCountry(gender, "*Please Select Gender");
    const CountryStatus = validatelCountry(
      country,
      "*Please Select Country",
      null
    );
    const StateStatus = validatelCountrySate(
      state,
      "*Please Select State",
      country
    );
    const cityStatus = validatelCountrySate(
      city,
      "Please Enter City ",
      country,
      city_name
    );
    const cityNameStatus = validatelotherCountryCity(
      "Please Enter City ",
      country,
      city_name
    );


    formStatus = {
      email_id: emailStatus.error,
      phonevalue: contactNoStatus.error,
      gender: genderStatus.error,
      country: CountryStatus.error,
      state: StateStatus.error,
      city: cityStatus.error,
      cityName:cityNameStatus.error,
      hasErrors:
        emailStatus.hasError ||
        contactNoStatus.hasError ||
        genderStatus.hasError ||
        CountryStatus.hasError ||
        StateStatus.hasError ||
        cityStatus.hasError ||
        cityNameStatus.hasError,
    };
    
    return formStatus;
  },

  validateStep3: (params) => {
    const { mentoratstartup, hoursperweek } = params;
    let formStatus = {};
    const mentoratstartupStatus = validateDesignation(
      mentoratstartup,
      "Please Enter Mentorship Startup"
    );
    const hoursperweekStatus = validateNumber(
      hoursperweek,
      "Please Enter Hours Per Week"
    );

    formStatus = {
      mentoratstartup: mentoratstartupStatus.error,
      hoursperweek: hoursperweekStatus.error,
      hasErrors: mentoratstartupStatus.hasError || hoursperweekStatus.hasError,
    };
    return formStatus;
  },
  validateStep4: (params) => {
    
    const {
      industry,
      subindustry,
      specialization,
      subspecialization,
      preferredStage,
    } = params;
    let formStatus = {};
    // const subindustryStatus2 = validateTotalSelectField(
    //   subindustry,
    //   "*Please Select Industry/Sector Keywords",
    //   subspecialization
    // );
    const subindustryStatus2 = validateSelectFieldMulti(
      subindustry,subspecialization,
      "*Please Select Industry / Sector - Keywords"
    );
    // const subspecializationStatus2 = validateTotalSelectField(
    //   subspecialization,
    //   "*Please Select Specialization/Function Keywords",
    //   subindustry
    // );
    const subspecializationStatus2 = validateSelectFieldMulti(
      subspecialization,subindustry,
      "*Please Select Function - Keywords"
    );
    const industryStatus = validateSelectField(
      industry,
      "*Please Select Industry"
    );
    // const subindustryStatus = validateSelectField(
    //   subindustry,
    //   "*Please Select Industry/Sector Keywords"
    // );

    const specializationStatus = validateSelectField(
      specialization,
      "*Please Select Specialization"
    );
    // const subspecializationStatus = validateSelectField(
    //   subspecialization,
    //   "*Please Select Specialization/Function Keywords"
    // );
    const preferredStageStatus = validateSelectField(
      preferredStage,
      "*Please Select Prefered Stages"
    );
    formStatus = {
      industry: industryStatus.error,
      subindustry: subindustryStatus2.error,
      specialization: specializationStatus.error,
      subspecialization: subspecializationStatus2.error,
      preferredStage: preferredStageStatus.error,
      hasErrors:
        industryStatus.hasError ||
        subindustryStatus2.hasError ||
        specializationStatus.hasError ||
        subspecializationStatus2.hasError ||
        preferredStageStatus.hasError,
    };
    return formStatus;
  },

  validateStep5: (params) => {
    
    const {linkedinurl, uploadResume, personalblogurl, disclaimer, shortDesription } = params;
    let formStatus = {};
    const linkedinUrlStatus = validateUrl(linkedinurl, "Please Enter Valid Url");
    const uploadResumeStatus = validateFile(
      uploadResume,
      "*Please Select Resume"
    );
    const disclaimerStatus = validateDisclaimer(disclaimer);
    const personalblogurlStatus = validateUrl(personalblogurl, "Please Enter Valid Url");
    const shortDesriptionStatus =
      validate200TextAreaNonMandatory(shortDesription,"*Please Enter Short Description");

    formStatus = {
      linkedinurl: linkedinUrlStatus.error,
      uploadResume: uploadResumeStatus.error,
      disclaimer: disclaimerStatus.error,
      personalblogurl: personalblogurlStatus.error,
      shortDesription: shortDesriptionStatus.error,
      hasErrors:
      linkedinUrlStatus.hasError ||
        uploadResumeStatus.hasError ||
        personalblogurlStatus.hasError ||
        disclaimerStatus.hasError ||
        shortDesriptionStatus.hasError,
    };
    return formStatus;
  },
};
